export default __webpack_public_path__ + "static/12_25-76dc0a5c8ff9e7794bd4aa1e2f9323e4.png";